import styled from 'styled-components';

export default styled.div`
  color: #738A94;
  font-size: 1.2rem;
  
  & > span {
    margin-left: 1rem;
    font-weight: ${props => Number(props.responses) < 4 ? 'bold' : 'inherit'};
    color: ${props => Number(props.responses) < 4 ? '#FF1A00' : 'inherit'};
  }
`;
